import classNames from 'classnames';
import type { CSSProperties } from 'react';
import React from 'react';
import styles from './index.module.scss';

// Based on https://github.com/zalog/placeholder-loading

interface ItemProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const Item = ({ children, className, ...rest }: ItemProps) => {
  return (
    <div className={classNames(styles['ph-item'], className)} {...rest}>
      {children}
    </div>
  );
};

interface ColumnProps {
  children?: React.ReactNode;
  span: 'half' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  className?: string;
  empty?: boolean;
  big?: boolean;
  style?: React.CSSProperties;
}

export const Column = ({ children, span, big, empty, ...rest }: ColumnProps) => {
  return (
    <div
      className={classNames(
        styles[`ph-col-${span || 12}`],
        {
          [styles.big]: big,
          [styles.empty]: empty,
        },
        rest.className
      )}
    >
      {children}
    </div>
  );
};

export const Picture: React.FC<{ className?: string; style?: CSSProperties }> = props => (
  <div style={props.style} className={classNames(styles[`ph-picture`], props.className)} />
);
export const Avatar = () => <div className={styles[`ph-avatar`]} />;
interface RowProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}
export const Row = ({ children, style }: RowProps) => (
  <div style={style} className={styles[`ph-row`]}>
    {children}
  </div>
);

/**
 * Fallbacks, useful with <Suspense />
 */
export function AppLoadingFallback() {
  return <div className={styles.appLoadingFallback} />;
}

export function RouteLoadingFallback() {
  return (
    <div className={styles.routeLoadingFallback}>
      <AppLoadingFallback />
    </div>
  );
}
